import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { SectionBase } from './base.section';
import { EditAssessmentRequestModel } from '../../edit-assessment-request.model';

@Injectable()
export class AssessmentProctoringSection extends SectionBase {

	constructor(private fb: UntypedFormBuilder) {
		super();
	}

	public get proctoringSelectionControl() {
		return this.formGroup.controls['proctoringSelection'] as UntypedFormControl;
	}

	public get acknowledgmentControl() {
		return this.formGroup.controls['proctoringAcknowledgment'] as UntypedFormControl;
	}

	public init({ assessmentRequest }: { assessmentRequest: EditAssessmentRequestModel }) {
		super.setAssessmentRequest(assessmentRequest);
		this.formGroup = this.buildFormGroup();
		this.proctoringSelectionControl.setValue(this.assessmentRequest.proctoringSelection || null);
		if (this.assessmentRequest.proctoringSelection) {
			this.acknowledgmentControl.setValue(true);
		}

		this.proctoringSelectionControl.valueChanges.subscribe(() => {
			this.acknowledgmentControl.setValue(false);
		});
	}

	public clear() {
		this.proctoringSelectionControl.setValue(null);
		this.acknowledgmentControl.setValue(false);
	}

	public get formValue(): any {
		return {
			proctoringSelection: this.formGroup.value.proctoringSelection
		};
	}

	protected buildFormGroup(): UntypedFormGroup {
		return this.fb.group({
			proctoringSelection: null,
			proctoringAcknowledgment: false
		});
	}
}